import { d as debounce } from './debounce-Dg7s1ivP.js';

class MainBlog extends HTMLElement {
  loading = false; // the default state
  form = this.querySelector('form');

  abortController = new AbortController();

  connectedCallback() {
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[type="search"]');

    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.fetchBlogs(this.input?.value || '');
    });

    this.input.addEventListener(
      'input',
      debounce(async () => {
        // Select the elements when we need it
        this.renderTarget = this.querySelector('[data-blog="target"]'); // This will be used for the section api to render the response
        this.originalContent = this.querySelector('[data-blog="original"]'); // This element will be the sever side loaded state.

        // Check if the input is empty
        if (this.input?.value === '' || this.input?.value.length < 2) {
          this.renderTarget.setAttribute('aria-hidden', 'true');
          this.originalContent.setAttribute('aria-hidden', 'false');
          return;
        }

        // Not empty try fo fetch the blog results
        await this.fetchBlogs(this.input?.value || '');
      }, 300)
    );
  }

  async fetchBlogs(query) {
    if (!query) return;

    this.toggleLoading();

    // Only search blogs (articles) - construct URL for @fetch-main-blog-results.liquid section endpoint
    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'article',
      'resources[limit]': 10,
      section_id: 'fetch-main-blog-results',
    });

    const url = `${Shopify.routes.root}search/suggest?${params.toString()}`;

    try {
      // Abort the previous request so we don't have multiple requests running at the same time
      this.abortController?.abort();
      this.abortController = new AbortController();

      const response = await fetch(url, { signal: this.abortController.signal });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');

      // Check if the response has the data-blog="results" element, if not throw an error
      const results = html.querySelector('[data-blog="results"]');
      if (!results) {
        throw new Error('No results found in the response');
      }

      this.renderTarget.innerHTML = results.innerHTML;
      this.originalContent.setAttribute('aria-hidden', 'true');
      this.renderTarget.setAttribute('aria-hidden', 'false');
    } catch (error) {
      console.error('Blog search fetch failed:', error);
      this.originalContent.setAttribute('aria-hidden', 'false');
      this.renderTarget.setAttribute('aria-hidden', 'true');
    } finally {
      this.toggleLoading(false);
    }
  }

  toggleLoading(loading = true) {
    this.loading = loading;
    this.form.setAttribute('aria-busy', loading ? 'true' : 'false');
  }
}

customElements.define('main-blog', MainBlog);
